import React from "react";
import { useNavigate } from "react-router-dom";
import { useBalk, balkLabel } from "@/lib/balkState";

// DE BALK — 6px welded to the bottom edge of the console. Resting is not an
// absence: it is a visible statement that every site in the strip is running.
// The strip is FIXED LENGTH: one segment per truckwash in service, and it never
// grows a segment for work that sits somewhere else (a pand, an opslag, a site
// that has not opened). Silhouette carries the state before colour does: a spoor out of service grows
// UPWARD into the band, an open P1 grows DOWNWARD and breaks the band's edge, so
// the two are unambiguous in pure monochrome, at three metres, on a wet screen.
//
// "I could not reach the server" is NOT resting. Unknown renders the trough
// alone, with no segments at all, and says so out loud.
export const SiteStrip = () => {
  const navigate = useNavigate();
  const { segments, status } = useBalk();

  if (status !== "ok" || segments.length === 0) {
    return (
      <div
        role="img"
        aria-label={balkLabel(segments, "unknown")}
        data-testid="site-strip"
        data-status="unknown"
        className="relative h-[6px] w-full bg-balk-trog"
      />
    );
  }

  return (
    <div
      role="img"
      aria-label={balkLabel(segments, status)}
      data-testid="site-strip"
      data-status="ok"
      className="relative flex h-[6px] w-full gap-[2px] bg-balk-trog"
    >
      {segments.map((s) => {
        const lit = s.state !== "rust";
        const clickable = lit && !!s.fault;
        const cls =
          s.state === "alarm"
            ? "h-[12px] self-start bg-balk-alarm"
            : s.state === "storing"
              ? "h-[12px] self-end bg-balk-storing"
              : "h-[6px] bg-balk-rust";
        return (
          <button
            key={s.id}
            type="button"
            tabIndex={clickable ? 0 : -1}
            aria-hidden={!lit}
            disabled={!clickable}
            data-testid={`site-segment-${s.id}`}
            data-state={s.state}
            title={
              lit
                ? `${s.name}${s.fault?.fault_number ? ` — ${s.fault.fault_number}` : " — machine buiten bedrijf"}`
                : undefined
            }
            onClick={() => clickable && navigate(`/storingen/${s.fault.id}`)}
            className={`relative z-10 min-w-0 flex-1 transition-[height] duration-150 ${cls} ${
              clickable ? "cursor-pointer" : "cursor-default"
            }`}
          />
        );
      })}
    </div>
  );
};
